module.exports = __webpack_public_path__ + "img/1.144b7bc9.png";